export default {
  wrongAddressFormat: 'Falsches Adressformat',
  disconnectWallet: 'Wallet trennen',
  memo: 'Memo',
  stage: 'Stufe',
  tokenomics: 'Tokenomics',
  tokensPurchased: 'Erworbene Token',
  youShouldAgree: 'Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen',
  requiredField: 'Pflichtfeld',
  minValueIs: 'Der Mindestwert beträgt',
  maxValueIs: 'Der Höchstwert beträgt',
  cannotCopyToClipboard: 'Kann nicht in die Zwischenablage kopiert werden',
  copiedToClipboard: 'In die Zwischenablage kopiert',
  failed: 'Aktion fehlgeschlagen',
  success: 'Aktion war erfolgreich',
  aboutUs: 'Über uns',
  bonuses: 'Boni',
  whitepaper: 'Whitepaper',
  team: 'Team',
  community: 'Community',
  checkAddress: 'Adresse überprüfen',
  currentPrice: 'AKTUELLER PREIS',
  bonusToBase: 'BONUS ZUM BASISPREIS',
  raised: 'erhöht',
  listingPrice: 'LISTENPREIS',
  scrollDownTo: 'Scrollen Sie nach unten, um mehr zu erfahren',
  keyFeaturesOf: 'Wichtige Funktionen der DOLLUM Wallet',
  essentialDollumFeatures:
    'Wichtige Funktionen der DOLLUM Wallet für Ihre Sicherheit und Ihren Komfort.',
  commissionOptimizer: 'Provisionsoptimierer',
  reduceTransactionCosts:
    'Reduzieren Sie Transaktionskosten, indem Sie automatisch die niedrigsten verfügbaren Gebühren auswählen.',
  emergencyStopMode: 'Not-Stopp-Modus',
  instantlyProtectAssets:
    'Schützen Sie Vermögenswerte sofort, indem Sie sie in Notfällen in USDT umwandeln.',
  antiHijackFeature: 'Anti-Hijack-Funktion',
  lockYourWallet:
    'Sperren Sie Ihre Wallet bei Bedrohung, indem Sie ein verstecktes Notsignal aktivieren.',
  cryptoInvestmentPortfolio: 'Krypto-Investmentportfolio',
  manageYourCrypto:
    'Verwalten Sie Ihre Krypto-Investitionen mit vorgefertigten Portfolios mit nur einem Klick.',
  backupAddress: 'Backup-Adresse',
  redirectAssetsTo:
    'Leiten Sie Vermögenswerte nach längerer Inaktivität an eine Backup-Adresse weiter.',
  bonusStages: 'BONUSSTUFEN',
  over320Million:
    'Über 320 Millionen Menschen weltweit nutzen Kryptowährungen, wodurch eine wachsende Nachfrage nach sicheren Krypto-Wallets und Finanzlösungen entsteht.',
  tokenStructure: 'TOKEN-STRUKTUR',
  onlyEmtVill: 'WÄHREND DES VORVERKAUFS WERDEN NUR 210.000.000 EMT AUSGEGEBEN!',
  remainingTokens: 'Verkaufte Token',
  totalRaised: 'Verkaufte Token insgesamt',
  other: 'Sonstiges',
  is: 'ist',
  connectWallet: 'Wallet verbinden',
  operationInProgress: 'Transaktion läuft',
  pleaseWait: 'Bitte warten',
  buying: 'Kaufen',
  for: 'für',
  confirmThisTransaction: 'Bestätigen Sie diese Transaktion in Ihrer Wallet',
  changeMetamaskWallet: 'Metamask Wallet ändern',
  connectedWith: 'Verbunden mit',
  copyAddress: 'Adresse kopieren',
  viewOnExplorer: 'Im Explorer anzeigen',
  checkAddressText:
    'Sie können die Adresse der Wallet eingeben, die Sie zum Kauf unserer Token verwendet haben, um deren Menge und Status anzuzeigen.',
  frozenFor: 'Eingefroren für ',
  month: 'Monat',
  months: 'Monate',
  scheduleOfThe: 'Zeitplan für die Freigabe der Gelder',
  back: 'ZURÜCK',
  available: 'Verfügbar',
  buy: 'Kaufen',
  enterTheWallet:
    'Geben Sie die Adresse ein, an die der DOLLUM-Token gesendet werden soll.',
  addressMustBe:
    'Verwenden Sie nur das BSC-Netzwerk, um Ihre Token sicher zu erhalten',
  youAreAt: 'Sie sind bei Schritt',
  of: 'von',
  notUseExchangeWallets:
    'Verwenden Sie nur DeFi-Wallets (z. B. MetaMask, Trust Wallet, Coinbase Wallet). Verwenden Sie keine Exchange-Wallets',
  continue: 'Weiter',
  youAreOnLast: 'Sie befinden sich im letzten Schritt',
  youMustTransfer: 'Sie müssen Gelder in Höhe von ... überweisen',
  address: 'Adresse',
  thisOperationTakes: 'Die Transaktion dauert bis zu 3 Stunden',
  update: 'Aktualisieren',
  copyTransactionHash: 'Transaktions-Hash kopieren',
  copy: 'Kopieren',
  depositTheSpecified: 'Zahlen Sie die angegebenen Gelder in diese Wallet ein',
  balance: 'Guthaben',
  receive: 'Erhalten',
  theOperationSuccessful: 'Die Transaktion war erfolgreich',
  yourFundsWill: 'Ihre Gelder werden an Ihre Wallet überwiesen',
  afterTheCompletion:
    'Nach Abschluss aller Vorverkaufsrunden beginnt der Freischaltungsprozess des DOL-Tokens',
  theAmountOf: 'Der Betrag in Höhe von',
  setOneText1:
    '1,5 Milliarden US-Dollar Marktwert für Krypto-Wallets im Jahr 2023',
  setOneText2:
    '40 % der Markteinnahmen werden durch den Krypto-Handel generiert',
  setOneText3:
    '50 % Wachstum bei Krypto-Überweisungen in den nächsten zehn Jahren',
  setTwoText1: '70% der Nutzer bevorzugen Staking und DeFi-Integration',
  setTwoText2:
    '175 Millionen US-Dollar potenzielle Einnahmen aus dem Token-Verkauf',
  setTwoText3:
    '10 % des Gesamtangebots sind für Marketinginitiativen vorgesehen',
  metric: 'Kennzahl',
  currentMarketState: 'Aktuelle Marktlage',
  forecastedGrowth: 'Prognostiziertes Wachstum',
  userSegments: 'Nutzersegmente',
  opportunitiesForDollum: 'Chancen für die DOLLUM Wallet',
  marketValue: 'Marktwert',
  retailInvestorsFinancial: 'Privatanleger, Finanzinstitute',
  increasingDemandFor: 'Steigende Nachfrage nach Krypto-Wallets',
  numberOfCrypto: 'Anzahl der Krypto-Nutzer',
  expectedToReach: 'Bis 2030 voraussichtlich über 500 Millionen Nutzer',
  youthEntrepreneursInstitutional:
    'Jugendliche, Unternehmer, institutionelle Kunden',
  attractNewUsers: 'Gewinnung neuer Nutzer durch DeFi',
  mobileWalletShare: 'Anteil mobiler Wallets',
  belongsToAndroid: '45 % des Marktes entfallen auf Android',
  mobileSolutionsExpected:
    'Mobile Lösungen werden voraussichtlich um 10 % jährlich wachsen',
  smartphoneUsers: 'Smartphone-Nutzer',
  convenienceAndMobile: 'Komfort und mobiler Zugriff',
  defiAndStacking: 'DeFi und Staking',
  integrationWithDefi: 'Integration mit DeFi-Protokollen',
  exponentialGrowthIn:
    'Exponentielles Wachstum der Nachfrage nach DeFi-Diensten',
  activeCryptoInvestors: 'Aktive Krypto-Investoren',
  directAccessTo: 'Direkter Zugang zu Staking und DEX',
  marketRegions: 'Marktregionen',
  marketLeaders: 'Marktführer: Nordamerika, Asien',
  asiaAndLatin: 'Asien und Lateinamerika – am vielversprechendsten',
  entrepreneursAndLow: 'Unternehmer und Nutzer mit geringem Einkommen',
  expansionIntoNew: 'Expansion in neue Märkte Expansion in neue Märkte',
  millionCryptoUsers: 'Millionen Krypto-Nutzer weltweit',
  allocationOfFunds: 'VERTEILUNG DER FONDS',
  seedRound: 'Seed-Runde',
  round: 'Runde',
  Round: 'Runde',
  tokenPrice: 'Token-Preis',
  privateRound: 'Private Runde',
  presaleRound: 'Vorverkaufsrunde',
  publicSaleRound: 'Öffentliche Verkaufsrunde',
  marketingCommunityBuilding: 'Marketing, Community-Aufbau, Airdrop',
  teamAndFounders: 'Team und Gründer',
  ecosystemDevelopmentFund: 'Ökosystem-Entwicklungsfonds',
  liquidityFund: 'Liquiditätsfonds',
  stakingRewards: 'Staking-Belohnungen',
  reserveFund: 'Reservefonds',
  usersChooseStaking: '70 % der Nutzer entscheiden sich für Staking in DOLLUM',
  theMajorityOf:
    'Die Mehrheit der DOLLUM Wallet-Nutzer beteiligt sich aktiv am Staking, um ein regelmäßiges Einkommen zu erzielen und am Wachstum des DeFi-Ökosystems teilzuhaben, wobei sie von einem hohen Effektivertrag und der Sicherheit der Wallet profitieren.',
  preliminaryEstimateBased:
    '**Dies ist eine vorläufige Schätzung basierend auf aktuellen Markttrends.',
  roadmapText1: 'Non-custodial Wallet',
  roadmapText1Part2: 'Wesentliche Custodial-Funktionen',
  roadmapText1Part3: 'Whitepaper',
  roadmapText2: 'Non-custodial Wallet',
  roadmapText2Part2: 'Wesentliche Custodial-Funktionen ',
  roadmapText2Part3: 'Whitepaper ',
  roadmapText3: 'Anti-Hijack',
  roadmapText3Part2: 'Wallet-Launch ',
  roadmapText3Part3: 'Backup-Adress-Funktion',
  roadmapText3Part4: 'Notfall-Überweisung ',
  roadmapText3Part5: 'Portfolio-Manager',
  roadmapText4: 'Tokenomics und Token-Verkauf',
  roadmapText4Part2: 'Provisionsoptimierer',
  roadmapText4Part3: 'Nachrichten innerhalb der Transaktion',
  roadmapText5: 'NFT in der Wallet',
  roadmapText5Part2: 'Kryptowährung mit Fiat kaufen',
  roadmapText5Part3: 'Swap unter Verwendung der Non-custodial Wallet-Funktion',
  roadmapText6: 'Öffentliche Beta',
  roadmapText6Part2:
    'Strategische Allianzen mit globalen Bankinstituten zur Integration des DOL-Tokens als Dollar-Standard-Vermögenswert.',
  roadmapText6Part3: 'Bankkarten',
  roadmapText6Part4: 'Listing an Krypto-Börsen',
  roadmapText6Part5: 'Dollum Kryptobörse Beta',
  roadmapText7: 'Wallet-Launch',
  roadmapText7Part2:
    'Einführung des DOL-Tokens als digitales Instrument für staatliche Initiativen.',
  roadmapText7Part3: 'Dollum-Blockchain',
  roadmapText7Part4: 'NFT-Marktplatz Beta',
  roadmapText8: 'Krypto-Börsen-Launch',
  roadmapText8Part2: 'NFT-Marktplatz-Launch',
  tokenRoadmap: 'Token-Roadmap',
  roadmap: 'Roadmap',
  competitorComparison: 'Vergleich mit Wettbewerbern',
  featureAttribute: 'Funktion/Eigenschaft',
  typeOfWallet: 'Art der Wallet',
  custodialNonCustodial: 'Custodial und Non-custodial',
  nonCustodial: 'Non-custodial',
  cryptocurrenciesSupported: 'Unterstützte Kryptowährungen',
  bitcoinEthereumTron: 'Bitcoin, Ethereum, Tron, Polygon usw.',
  thousandCoins: 'Über 1.000 Coins',
  ethereumTokens: 'Ethereum, ERC-20-Token',
  assets130: 'Über 130 Vermögenswerte',
  assets500: 'Über 500 Vermögenswerte',
  supportedPlatforms: 'Unterstützte Plattformen',
  defiIntegration: 'DeFi-Integration',
  yes: 'Ja',
  stakingSupport: 'Staking-Unterstützung',
  no: 'Nein',
  tokenSwapping: 'Token Swapping',
  yesNativeExternal: 'Ja (nativ und extern)',
  securityFeatures: 'Sicherheitsfunktionen',
  biometricPassword: 'Biometrisch, Passwort',
  passwordPrivateKey: 'Passwort, privater Schlüssel',
  biometric2Fa: 'Biometrisch, 2FA',
  kycCompliance: 'KYC/AML-Konformität',
  yesForCustodial: 'Ja (für custodial)',
  backupRecovery: 'Sicherung und Wiederherstellung',
  yesSeedPhrases: 'Ja (Seed-Phrasen, 2FA)',
  yesSeedPhrase: 'Ja (Seed-Phrase)',
  supportedBlockchains: 'Unterstützte Blockchains',
  multiBlockChainCustom: 'Multi-Blockchain (anpassbar)',
  multiBlockchain: 'Multi-Blockchain',
  userInterface: 'Benutzeroberfläche',
  intuitiveCustomizable: 'Intuitiv, anpassbar (dunkles/helles Design)',
  simpleCleanInterface: 'Einfache, übersichtliche Benutzeroberfläche',
  simpleDeveloperFocused: 'Einfach, auf Entwickler ausgerichtet',
  cleanAndUser: 'Übersichtlich und benutzerfreundlich',
  visualAppealing: 'Optisch ansprechend, anpassbar',
  cleanSimple: 'Übersichtlich, einfach',
  crossChainSwapping: 'Cross-Chain Swapping',
  fees: 'Gebühren',
  adjustableOptimizedUsing: 'Anpassbar, optimiert mit dem Provisionsoptimierer',
  adjustable: 'Anpassbar',
  fixedForCustodial: 'Fest für custodial; anpassbar für non-custodial',
  backupAddressFeature: 'Backup-Adress-Funktion',
  yesNonCustodial: 'Ja (non-custodial)',
  pushNotifications: 'Push-Benachrichtigungen',
  hardwareWalletSupport: 'Unterstützung für Hardware-Wallets',
  yesViaTrezor: 'Ja (über Trezor)',
  yesLedgerTrezor: 'Ja (Ledger/Trezor)',
  yesTrezor: 'Ja (Trezor)',
  yesLedger: 'Ja (Ledger)',
  nftSupport: 'NFT-Unterstützung',
  feeOptimization: 'Gebührenoptimierung',
  yesCommissionOptimizer: 'Ja (Provisionsoptimierer)',
  twoFactorAuth: 'Zwei-Faktor-Authentifizierung (2FA)',
  fiatConversion: 'Fiat-Umwandlung',
  yesCustodialOnly: 'Ja (nur custodial)',
  mobileSpecificFeatures: 'Mobilgeräte-spezifische Funktionen',
  storiesEmergencyStop: 'Stories, Not-Stopp, Anti-Hijack',
  none: 'Keine',
  adminPanel: 'Admin-Panel',
  yesCustodialService: 'Ja (für Depotdienstleistungen)',
  nativeDexAddress: 'Nativer DEX-Zugriff',
  decentralizedAppBrowser: 'Dezentralisierter App-Browser',
  biometricLogin: 'Biometrische Anmeldung',
  reputationSystem: 'Reputationssystem',
  yesInternalWallet: 'Ja (interne Wallet-Bewertung)',
  additionalSecurityTools: 'Zusätzliche Sicherheitstools',
  emergencyStopAnti: 'Not-Stopp, Anti-Hijack',
  languagesSupport: 'Unterstützte Sprachen',
  multiLanguageSupport: 'Mehrsprachige Unterstützung',
  english: 'Englisch',
  customerSupport: 'Kundensupport',
  yesBuildIt: 'Ja (integrierte Support-Optionen)',
  yesHelpCenter: 'Ja (Hilfezentrum)',
  yes24Support: 'Ja (24/7-Support)',
  yesInApp: 'Ja (In-App-Support)',
  frequentlyAskedQuestions: 'HÄUFIG GESTELLTE FRAGEN',
  howFindFrequently:
    'Hier finden Sie alle häufig gestellten Fragen zu unserem Produkt',
  faqTitle1: 'Wie erstelle ich eine Wallet in der DOLLUM Wallet?',
  faqTitle2: 'Welche Gebühren fallen für die DOLLUM Wallet an?',
  faqTitle3: 'Unterstützt die Wallet die DeFi-Integration?',
  faqTitle4: 'Wie verwende ich die Not-Stopp-Funktion?',
  faqTitle5:
    'Kann die DOLLUM Wallet zur Speicherung von NFTs verwendet werden?',
  faqTitle6:
    'Wie kann ich den Zugriff auf meine Wallet wiederherstellen, wenn mein Gerät verloren geht?',
  faqText1:
    'Um eine Wallet zu erstellen, laden Sie einfach die App herunter, schließen Sie die Registrierung ab, wählen Sie den Wallet-Typ (custodial/non-custodial) und speichern Sie Ihre Seed-Phrase sicher, um Zugang zu erhalten.',
  faqText2:
    'Die DOLLUM Wallet optimiert automatisch die Transaktionsgebühren, indem sie die niedrigsten verfügbaren Tarife auswählt und so die Kosten für den Benutzer während der Nutzung optimiert.',
  faqText3:
    'Ja, die DOLLUM Wallet unterstützt DeFi-Protokolle vollständig und ermöglicht es Benutzern, über integrierte DEXs an Staking, Farming und Token-Swaps teilzunehmen.',
  faqText4:
    'Die Not-Stopp-Funktion wandelt Vermögenswerte sofort in Stablecoins um oder sperrt die Wallet, wenn die Sicherheit bedroht ist. Sie kann über die Einstellungen der Wallet aktiviert werden.',
  faqText5:
    'Ja, die DOLLUM Wallet unterstützt die Speicherung, Anzeige und den Handel von NFTs und ermöglicht Nutzern die sichere Verwaltung ihrer digitalen Sammlungen direkt in der Wallet.',
  faqText6:
    'Sie können den Zugriff auf Ihre Wallet mithilfe der Seed-Phrase wiederherstellen, die bei der Erstellung der Wallet bereitgestellt wurde. Bewahren Sie die Seed-Phrase an einem sicheren Ort auf.',
  footerReservedText:
    'Die Website wird von SecureLabs LTd betrieben, einer nach dem Recht der Seychellen gegründeten Gesellschaft mit Sitz in: Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seychelles. Alle Rechte vorbehalten',
  termsOfUse: 'Nutzungsbedingungen',
  privacyPolicy: 'In der Datenschutzrichtlinie zu',
  cookiePreferences: 'Cookie-Einstellungen',
  agreeToTransaction: 'Ich stimme der Transaktion sowie den Klauseln in den ',
  and: 'und',
  termsAndConditions: 'Allgemeinen Geschäftsbedingungen',
  alsoYouCan:
    'Sie können die Bestätigung Ihrer Zuteilung auch auf ... überprüfen, ',
  usingTheTransaction:
    'indem Sie den Transaktions-Hash verwenden. Sie können den detaillierten Freischaltungszeitplan Ihrer DOL-Token jederzeit auf dieser Website einsehen, indem Sie die Empfangsadresse angeben.',
  followUsOn: 'Folgen Sie uns in den sozialen Medien',
  lockedFor: 'Gesperrt für',
  selectNetwork: 'Netzwerk auswählen',
  dolTokenWill: 'Der DOL-Token wird im Binance Smart Chain-Netzwerk eingeführt',
  copyTxHash: 'Tx-Hash kopieren',
  theOperationExpired: 'Der Vorgang ist abgelaufen',
  waitingTimeHas: 'Die Wartezeit ist abgelaufen, versuchen Sie es erneut',
  ifTheProblem: 'Wenn das Problem erneut auftritt, ',
  sendUsEmail: 'senden Sie uns bitte eine E-Mail',
  contactSupport: 'kontaktieren Sie bitte den Support',
  tryAgain: 'Versuchen Sie es bitte erneut',
  theOperationFailed: 'Der Vorgang ist fehlgeschlagen',
  error: 'Fehler',
  tokenUnlockingSchedule: 'Token-Freischaltungszeitplan:',
  promoCodeUsed: 'Der Promo-Code wurde erfolgreich verwendet',
  congratulations: 'Herzlichen Glückwunsch',
  youCanActivate: 'Sie können den Promo-Code für ... aktivieren ',
  activateYourPromocode: 'Aktivieren Sie Ihren Promo-Code',
  getting: 'Erhalten',
  totalRaisedInUsd: 'Gesamt gestiegen',
  nextStage: 'Nächste Stufe',
  pay: 'Bezahlen',
  info: 'Info',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '1,5 Milliarden US-Dollar im Jahr 2023',
  bonusRowsGrowth1: '1,5 Milliarden US-Dollar im Jahr 2023',
  bonusRowsState2: 'Über 320 Millionen Krypto-Nutzer',
  multiformatSupport: 'Bitcoin, Ethereum, ERC-20',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Light-Version)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Browser',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometrisch, PIN, 2FA, SSL-Pinning, AES-256-Verschlüsselung, Not-Stopp, Anti-Hijack',
  ethereum: 'Ethereum',

  poweredBy: 'Bereitgestellt von',
  live: 'Live',
  auditAndKycVerified: 'Audit & KYC verifiziert',
  teamKycVerification: 'Team-KYC-Verifizierung',
  smartContractAudit: 'Smart-Contract-Audit',
  securityComesFirst: 'Sicherheit hat Vorrang.',
  ourSmartContractHasBeenFullyAudited:
    'Unser Smart Contract wurde vollständig auditiert',
  bySolidProof: 'von SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'eines der führenden Blockchain-Audit-Unternehmen.',
  additionally: 'Zusätzlich,',
  dollumTeamCompletedKYC:
    'das Dollum-Team hat die KYC-Verifizierung erfolgreich abgeschlossen',
  ensuringTransparencyAndAccountability:
    ', um Transparenz und Rechenschaft für unsere Community zu gewährleisten.',
  servicesAndCertificates: 'Dienstleistungen & Zertifikate',
  kyc: 'KYC',
  securityScore: 'Sicherheitsbewertung',
  poor: 'Schlecht',
  excellent: 'Ausgezeichnet',
  writesMediaAboutUs: 'Medien über uns',

  stageTwoAlmostSold: 'Phase 2 fast ausverkauft — Nächster Preis: $0.20',
  buyBeforeThePriceIncreases: 'Jetzt für $0.15 kaufen, bevor der Preis steigt!',

  useOnlyDefiWallet:
    'Verwenden Sie nur ein DeFi-Wallet wie MetaMask, Trust Wallet oder Coinbase Wallet.',
  makeSureYourWalletIsConnectedToTheBsc:
    'Stellen Sie sicher, dass Ihr Wallet mit dem BSC-Netzwerk (Binance Smart Chain) verbunden ist.',
  copyYourBscWalletAddress:
    'Kopieren Sie Ihre BSC-Wallet-Adresse (sie beginnt mit 0x) und fügen Sie sie in das Feld ein.',
  doNotUseExchangeWallets:
    'Verwenden Sie keine Exchange-Wallets (wie Binance, KuCoin oder OKX).',

  needHelp: 'Brauchst du Hilfe?',

  stage3IsSellingFast: 'Letzte Presale-Phase — Letzte Chance vor dem Listing',
  nextStagePriceIncreases:
    'Sichern Sie sich jetzt Ihre Tokens vor dem geplanten ersten Listing-Preis von 1,00 $',
  finalPresaleStage: 'Letzte Presale-Phase',

  weAreLive: 'Wir sind live!',
  weWillLiveSoon: 'Wir gehen bald live',
  startManagingYourCryptoSecurely:
    'Beginnen Sie, Ihre Krypto sicher zu verwalten',
  launchpadIntroduction: 'Einführung des Launchpads',
  continuedPlatformDevelopment:
    'Fortlaufende Plattformentwicklung und Erweiterung des Ökosystems',
  expansionIntoIntegratedFinancialServices:
    'Erweiterung in integrierte Finanzdienstleistungen, einschließlich Zahlungs- und Kreditfunktionen',
  ecosystemScaling: 'Skalierung des Ökosystems und Erweiterung der Funktionen',
  platformOptimizationAndInfrastructure:
    'Plattformoptimierung und Stärkung der Infrastruktur',
  platformForBroaderMarketIntegration:
    'Vorbereitung auf eine breitere Marktintegration',
  structuredDigitalFinanceEcosystem:
    'EIN STRUKTURIERTES DIGITALES FINANZÖKOSYSTEM',
  dollumCombinesSecureWallet:
    'Dollum kombiniert eine sichere Wallet-Infrastruktur, Staking und integrierte Finanztools in einer einheitlichen Plattform — mit Erweiterung auf Zahlungs- und Kreditfunktionen.',
  finalStageLimitedAllocationRemaining:
    'Endphase – begrenzte Zuteilung verbleibend',

  nowAvailable: 'Jetzt verfügbar',
  digitalAssetManagement:
    'Verwaltung digitaler Vermögenswerte mit integrierten Zahlungsfunktionen',
};
